module.exports = __webpack_public_path__ + "static/23-b45b1c0ef7f5c27328971c9ad71facaf.png";